export default __webpack_public_path__ + "static/media/checkbox-full-enabled.icon.dec1b724.svg";